/* @flow */
import * as React from 'react';

import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Text from 'components/Text';
import MediaObject from 'components/MediaObject';
import Button from 'components/Button';
import LinkConstants from 'constants/LinkConstants';

type Props = {
  inPaidOrg: boolean,
};

class IndividualPlanOrgUpsellView extends React.Component<Props> {
  render() {
    const { inPaidOrg } = this.props;

    const upSellOrgSection = (
      <Box
        title={
          <MediaObject center figure="right">
            <Text align="left" size="medium" weight="semibold">
              School &amp; District Plans
            </Text>
            {inPaidOrg && (
              <Text data-test="current-plan" size="small">
                You are currently on this plan
              </Text>
            )}
          </MediaObject>
        }
        dark
        headerSize="xsmall">
        <BoxBody size="small">
          <MediaObject figure="right">
            <Text align="left" size="medium" wrap>
              Premium Features available for your organization. An administrator is required to
              purchase this plan
            </Text>
            {!inPaidOrg && (
              <Button data-test="upsell-button" level="primary" href={LinkConstants.PLANS}>
                Learn More
              </Button>
            )}
          </MediaObject>
        </BoxBody>
      </Box>
    );

    return <React.Fragment>{upSellOrgSection}</React.Fragment>;
  }
}

export default IndividualPlanOrgUpsellView;
